/**
 * @description 库存汇总ui模块
 */
<template>
  <div v-loading="loading">
    <el-row type="flex" :gutter="44" style="overflow: auto; padding-right: 12px">
      <el-col :span="5">
        <InventoryRing
          type="已下单"
          :currencySymbol="storageAnalysisTotal.currencySymbol"
          :total="storageAnalysisTotal.quantityTotal"
          :number="storageAnalysisTotal.alreadyOrderQuantity"
          :amount="storageAnalysisTotal.alreadyOrderQuantityValue"
          :proportion="storageAnalysisTotal.alreadyOrderQuantityRate"
          color="#1F6EEF"
        />
      </el-col>
      <el-col :span="5">
        <InventoryRing
          type="可用量"
          :currencySymbol="storageAnalysisTotal.currencySymbol"
          :total="storageAnalysisTotal.quantityTotal"
          :number="storageAnalysisTotal.availableQuantity"
          :amount="storageAnalysisTotal.availableQuantityValue"
          :proportion="storageAnalysisTotal.availableQuantityRate"
          color="#FF7A8C"
        />
      </el-col>
      <el-col :span="5">
        <InventoryRing
          type="待出运"
          :currencySymbol="storageAnalysisTotal.currencySymbol"
          :total="storageAnalysisTotal.quantityTotal"
          :number="storageAnalysisTotal.waitShipmentQuantity"
          :amount="storageAnalysisTotal.waitShipmentQuantityValue"
          :proportion="storageAnalysisTotal.waitShipmentQuantityRate"
          color="#F6BD14"
        />
      </el-col>
      <el-col :span="5">
        <InventoryRing
          type="在途量"
          :currencySymbol="storageAnalysisTotal.currencySymbol"
          :total="storageAnalysisTotal.quantityTotal"
          :number="storageAnalysisTotal.transitQuantity"
          :amount="storageAnalysisTotal.transitQuantityValue"
          :proportion="storageAnalysisTotal.transitQuantityRate"
          color="#51D351"
        />
      </el-col>
      <el-col :span="5">
        <InventoryRing
          type="FBA可售量"
          :currencySymbol="storageAnalysisTotal.currencySymbol"
          :total="storageAnalysisTotal.quantityTotal"
          :number="storageAnalysisTotal.fullFillAbleQuantity"
          :amount="storageAnalysisTotal.fullFillAbleQuantityValue"
          :proportion="storageAnalysisTotal.fullFillAbleQuantityRate"
          color="#945FB9"
        />
      </el-col>
    </el-row>
    <el-row type="flex" :gutter="44">
      <el-col :span="12" class="ring-total">
        <div class="cell total">合计：{{ storageAnalysisTotal.quantityTotal || 0 }}</div>
        <div class="cell">总货值：{{ storageAnalysisTotal.currencySymbol }}{{ storageAnalysisTotal.valueTotal || 0 }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getStorageAnalysisTotal } from "@/api/statistics";
import InventoryRing from "./inventory-ring.vue";
export default {
  inject: ['getPageParams', 'generatorPageParams'],
  computed: {
      pageParams () {
          return this.getPageParams()
      },
  },
  components: { InventoryRing },
  data() {
    return {
      loading: true,
      storageAnalysisTotal: {},
    };
  },
  methods: {
    // 获取库存分析汇总数据
    async getStorageAnalysisTotal() {
        let params = {
          asinCode: this.pageParams.asinCode,
          asinType: this.pageParams.asinType,
          countryIds: this.pageParams.countryData.countryIds,
          marketIds: this.pageParams.countryData.marketIds
        }
        let res = await getStorageAnalysisTotal(params);
        this.storageAnalysisTotal = res || {};
        this.loading = false
    },
  },
  created() {
    this.getStorageAnalysisTotal();
  },
};
</script>

<style scoped lang="scss">
.ring-total {
  line-height: 1;
  font-size: 14px;
  padding: 6px 0 20px;
  display: flex;
  color: #666;
  .cell {
    padding-left: 12px;
    &.total {
      width: 125px;
    }
  }
}
</style>